<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let metadata = {}
    export let page = 0

    function navigate(to) {

        if(to === 'previous' && metadata.previous != null && metadata.previous != undefined) {
            page = metadata.previous
            dispatch('change')
        }

        if(to === 'next' && metadata.next != null && metadata.next != undefined) {
            page = metadata.next
            dispatch('change')
        }
    }

</script>

<div class="items-end">
    <div class="field has-addons">
        <div class="control">
            <button on:click={() => navigate('previous')} class="button is-small" disabled={ metadata.previous === null || metadata.previous === undefined }>
                <span class="icon"><i class="fas fa-angle-left"></i></span>
            </button>
        </div>
        {#if page}
            <div class="control">
                <button class="button is-small is-count" disabled>
                    <span>{ page }</span>
                </button>
            </div>
        {/if}
        <div class="control">
            <button on:click={() => navigate('next')} class="button is-small" disabled={ metadata.next === null || metadata.next === undefined }>
                <span class="icon"><i class="fas fa-angle-right"></i></span>
            </button>
        </div>
    </div>
</div>